(function (Drupal, once) {
  'use strict';

  // Ferme les menus déroulants desktop (.menu-parent) actuellement ouverts.
  // Cette fermeture passe par le plugin jQuery de Bootstrap 4 car celui-ci
  // gère aussi la destruction de l'instance Popper.js associée au dropdown :
  // la reproduire nous-mêmes en vanilla (classes + aria-expanded) laisserait
  // le positionnement Popper et les listeners tactiles internes de
  // Bootstrap dans un état incohérent. jQuery est de toute façon une
  // dépendance incontournable du site tant que bootstrap4 (thème de base)
  // est utilisé.
  function closeOpenDropdowns() {
    document
      .querySelectorAll('.nav-item.nav-link.menu-parent.active.menu-with-arrow[aria-expanded="true"]')
      .forEach((toggle) => {
        jQuery(toggle).dropdown('toggle');
      });
  }

  Drupal.behaviors.togglMenu = {
    attach(context) {
      once('togglMenu', '[data-event=toggle-menu]', context).forEach((element) => {
        element.addEventListener('click', () => {
          Drupal.behaviors.togglMenu.toggl();
        });
      });

      // Au clic sur le bouton "Vous êtes" (#open-menu / .bouton-mobile-vousetes).
      // IMPORTANT : ce binding doit vivre dans un Drupal.behaviors + once(),
      // pas au top-level du fichier — avec BigPipe actif sur ce site, le
      // bloc contenant ce bouton peut arriver dans le DOM *après* le
      // chargement initial (placeholder rempli plus tard). Un binding
      // exécuté une seule fois au parsing du script raterait alors
      // silencieusement l'élément (constaté : ça marche en anonyme, jamais
      // en admin, où plus de contenu est marqué "personnalisé" par Drupal
      // et donc différé par BigPipe).
      once('vousEtesOpenButton', '.bouton-mobile-vousetes', context).forEach((button) => {
        button.addEventListener('click', () => {
          Drupal.behaviors.togglMenu.toggl();
        });
      });
    },

    // Ouvre/ferme le sous-menu "Vous êtes" : panneau + overlay grisé en
    // desktop, accompagne le burger menu en mobile.
    toggl() {
      const isDesktop = window.matchMedia('(min-width: 992px)').matches;
      document.querySelectorAll('.navigation-vousetes').forEach((nav) => {
        if (nav.classList.contains('ouvrirSousmenu')) {
          // Le menu est ouvert : on le ferme.
          nav.classList.remove('ouvrirSousmenu');
          if (isDesktop) {
            nav.classList.add('fermerSousmenu');

            document.querySelectorAll('.partie-grisee').forEach((el) => {
              el.classList.remove('ouvrirSousmenu');
              el.classList.add('fermerSousmenu');
            });
            document.body.classList.remove('menu-is-open');
            window.checkResize();
          } else {
            const burger = document.querySelector('.boutonMenuBurger');
            if (burger && burger.getAttribute('aria-expanded') === 'true') {
              nav.classList.add('fermerSousmenu');
            }
          }

          // Remise du menu "vous êtes" sur son 1er sous-menu.
          if (nav.sideMenuInstance) {
            nav.sideMenuInstance.back();
          }
        } else {
          // Le menu est fermé : on l'ouvre.
          if (isDesktop) {
            closeOpenDropdowns();

            nav.classList.remove('fermerSousmenu');
            nav.classList.add('ouvrirSousmenu');

            document.querySelectorAll('.partie-grisee').forEach((el) => {
              el.classList.remove('fermerSousmenu');
              el.classList.add('ouvrirSousmenu');
            });
            document.body.classList.add('menu-is-open');
            window.checkResize();
          } else {
            const burger = document.querySelector('.boutonMenuBurger');
            if (burger && burger.getAttribute('aria-expanded') === 'true') {
              nav.classList.remove('fermerSousmenu');
              nav.classList.add('ouvrirSousmenu');
            }
          }
        }
      });

      // Changement du chevron en vue desktop.
      const chevron = document.getElementById('chevron-up-down');
      if (chevron) {
        chevron.classList.toggle('arrow_menu_with_submenus_vousetes');
        chevron.classList.toggle('arrow_menu_with_submenus_vousetes_close');
      }
    },
  };

  // Mode mobile : à la fermeture du burger menu (.overlay-menu, un
  // `.collapse` Bootstrap 4), on referme le sous-menu "vous êtes" sans
  // animation et on le remet sur son 1er niveau.
  // Les évènements show/hide.bs.collapse de Bootstrap 4 sont déclenchés via
  // le bus d'évènements interne de jQuery (`$.Event`), pas via
  // `dispatchEvent` : ils ne sont pas observables en JS natif. Bootstrap
  // manipule en revanche la classe `.show` via de vraies mutations du DOM,
  // qu'on peut donc observer nativement.
  Drupal.behaviors.overlayMenuCollapse = {
    attach(context) {
      once('overlayMenuCollapse', '.overlay-menu', context).forEach((overlayMenu) => {
        if (!window.matchMedia('(max-width: 991px)').matches) {
          return;
        }

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            const wasOpen = (mutation.oldValue || '').split(' ').includes('show');
            const isOpen = overlayMenu.classList.contains('show');

            if (wasOpen && !isOpen) {
              document.querySelectorAll('.navigation-vousetes').forEach((nav) => {
                nav.classList.remove('fermerSousmenu', 'ouvrirSousmenu');
                if (nav.sideMenuInstance) {
                  nav.sideMenuInstance.back();
                }
              });
            }
          });
        });

        observer.observe(overlayMenu, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
      });
    },
  };

  // Renvoie les ancêtres de `el` correspondant à `selector`, du plus proche
  // au plus lointain (équivalent de jQuery .parents(selector)).
  function getAncestors(el, selector) {
    const result = [];
    let node = el.parentElement;
    while (node) {
      if (node.matches(selector)) {
        result.push(node);
      }
      node = node.parentElement;
    }
    return result;
  }

  const DEFAULT_OPTIONS = {
    position: 'right',
    keycodeOpen: null,
    keycodeClose: 27, // Esc
  };

  // Menu latéral coulissant multi-niveaux ("Vous êtes") : navigation entre
  // sous-menus imbriqués via un décalage CSS (translateX) du slider
  // contenant les <ul>, avec bouton "retour".
  class sideMenu {
    constructor(menu, options) {
      this.options = { ...DEFAULT_OPTIONS, ...options };
      this._menu = menu;

      // Ajoute un wrapper .slider autour du 1er <ul>
      const firstUl = this._menu.querySelector('ul');
      this._slider = document.createElement('div');
      this._slider.className = 'slider';
      firstUl.parentNode.insertBefore(this._slider, firstUl);
      this._slider.appendChild(firstUl);

      this._anchors = Array.from(this._menu.querySelectorAll('a'));

      this._level = 0;
      this._isOpen = false;
      this._isAnimating = false;
      this._hasMenu = this._anchors.length > 0;
      this._lastAction = null;

      this._setupEventHandlers();
      this._setupMenu();

      if (this._hasMenu) {
        this._setupSubmenus();
      }
    }

    /**
     * Toggle the menu
     * @param {boolean|null} open
     * @param {boolean} animate
     */
    toggle(open = null, animate = true) {
      let offset;

      if (open === null) {
        if (this._isOpen) {
          this.close();
        } else {
          this.open();
        }
        return;
      }

      if (open) {
        offset = 0;
        this._isOpen = true;
      } else {
        offset = this.options.position === 'left' ? '-100%' : '100%';
        this._isOpen = false;
      }

      this._triggerEvent();

      if (animate) {
        this._triggerAnimation(this._menu, offset);
      } else {
        this._pauseAnimations(() => this._triggerAnimation(this._menu, offset));
        this._isAnimating = false;
      }
    }

    /**
     * Open the menu
     * @param {boolean} animate Use CSS transitions
     */
    open(animate = true) {
      this._lastAction = 'open';
      this.toggle(true, animate);
    }

    /**
     * Close the menu
     * @param {boolean} animate Use CSS transitions
     */
    close(animate = true) {
      this._lastAction = 'close';
      this.toggle(false, animate);
    }

    /**
     * Navigate one menu hierarchy back if possible
     */
    back() {
      this._lastAction = 'back';
      this._navigate(null, -1);
    }

    /**
     * Navigate to a specific link on any level (useful to open the correct
     * hierarchy directly)
     * @param {string|Element} target A CSS selector or a DOM element
     */
    navigateTo(target) {
      const targetEl = typeof target === 'string' ? this._menu.querySelector(target) : target;

      if (!targetEl || !this._menu.contains(targetEl)) {
        return false;
      }

      const parents = getAncestors(targetEl, 'ul');
      const level = parents.length - 1;

      if (level === 0) {
        return false;
      }

      this._pauseAnimations(() => {
        this._level = level;
        parents.forEach((ul) => {
          ul.style.display = 'block';
        });
        parents[0].classList.add('active');
        this._triggerAnimation(this._slider, -this._level * 100);
      });

      return true;
    }

    /**
     * Set up all event handlers
     * @private
     */
    _setupEventHandlers() {
      this._anchors.forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          this._navigate(event.currentTarget);
        });
      });

      [this._menu, this._slider].forEach((el) => {
        el.addEventListener('transitionend', () => {
          this._isAnimating = false;
          this._triggerEvent(true);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.keyCode === this.options.keycodeClose) {
          this.close();
        } else if (this.options.keycodeOpen !== null && event.keyCode === this.options.keycodeOpen) {
          this.open();
        } else {
          return;
        }
        event.preventDefault();
      });

      this._menu.addEventListener('sm.back-after', () => {
        const lastActiveSelector = `ul ${'.active '.repeat(this._level + 1)}`.trim();
        const lastActiveUl = this._menu.querySelector(lastActiveSelector);
        if (lastActiveUl) {
          lastActiveUl.classList.remove('active');
          lastActiveUl.style.display = 'none';
        }
      });
    }

    /**
     * Trigger a custom event to support callbacks
     * @param {boolean} afterAnimation Mark this event as `before` or `after` callback
     * @private
     */
    _triggerEvent(afterAnimation = false) {
      let eventName = `sm.${this._lastAction}`;
      if (afterAnimation) {
        eventName += '-after';
      }
      this._menu.dispatchEvent(new CustomEvent(eventName));
    }

    /**
     * Navigate the _menu - that is slide it one step left or right
     * @param {Element|null} anchor The clicked anchor element
     * @param {number} dir Navigation direction: 1 = forward, -1 = backwards
     * @private
     */
    _navigate(anchor, dir = 1) {
      // Abort if an animation is still running
      if (this._isAnimating) {
        return;
      }

      const offset = (this._level + dir) * -100;

      if (dir > 0) {
        const submenu = anchor.nextElementSibling;
        if (!submenu || submenu.tagName !== 'UL') {
          return;
        }
        submenu.classList.add('active');
        submenu.style.display = 'block';
      } else if (this._level === 0) {
        return;
      }

      this._lastAction = dir > 0 ? 'forward' : 'back';
      this._level += dir;

      this._triggerAnimation(this._slider, offset);
    }

    /**
     * Start the animation (the CSS transition)
     * @param elem
     * @param offset
     * @private
     */
    _triggerAnimation(elem, offset) {
      this._triggerEvent();

      let value = offset;
      if (!String(value).includes('%')) {
        value += '%';
      }

      elem.style.transform = `translateX(${value})`;
      this._isAnimating = true;
    }

    /**
     * Initialize the menu
     * @private
     */
    _setupMenu() {
      this._pauseAnimations(() => {
        if (this.options.position === 'left') {
          this._menu.style.left = '0';
          this._menu.style.right = 'auto';
          this._menu.style.transform = 'translateX(-100%)';
        } else {
          this._menu.style.left = 'auto';
          this._menu.style.right = '0';
        }
      });
    }

    /**
     * Pause the CSS transitions, to apply CSS changes directly without an animation
     * @param work
     * @private
     */
    _pauseAnimations(work) {
      this._menu.classList.add('no-transition');
      work();
      void this._menu.offsetHeight; // force un reflow, appliquant les changements CSS sans transition
      this._menu.classList.remove('no-transition');
    }

    /**
     * Enhance the markup of menu items which contain a submenu: prevent
     * default behaviour (their href is only used to navigate the slider).
     * @private
     */
    _setupSubmenus() {
      this._anchors.forEach((anchor) => {
        const submenu = anchor.nextElementSibling;
        if (submenu && submenu.tagName === 'UL') {
          anchor.addEventListener('click', (event) => event.preventDefault());
        }
      });
    }
  }

  // Contrôles génériques (boutons "retour", etc.) reliés à l'instance
  // sideMenu du menu ciblé.
  // IMPORTANT : ce binding est fait ici, une seule fois au chargement du
  // script — PAS via once()+context dans un Drupal.behaviors. document.body
  // existe toujours dès qu'un script s'exécute, contrairement à once('...',
  // 'body', context) qui cherche un <body> *à l'intérieur* de `context` :
  // avec BigPipe, `context` lors de l'attach() d'un placeholder est un
  // fragment de DOM qui ne contient jamais <body> comme descendant (body
  // est un ancêtre du fragment, jamais un enfant) — le listener n'était
  // donc jamais posé pour les utilisateurs admin (constaté : le bouton
  // "Retour" rechargeait la page au lieu de naviguer, uniquement en admin).
  document.body.addEventListener('click', (event) => {
    const control = event.target.closest('.slide-menu-control');
    if (!control) {
      return;
    }

    const targetId = control.dataset.target;
    const menu = !targetId || targetId === 'this'
      ? control.closest('.slide-menu')
      : document.getElementById(targetId);

    if (!menu || !menu.sideMenuInstance) {
      return;
    }

    const action = control.dataset.action;
    if (typeof menu.sideMenuInstance[action] === 'function') {
      menu.sideMenuInstance[action]();
    }

    event.preventDefault();
  });

  Drupal.behaviors.sideMenu = {
    attach(context) {
      // Initialisation du plugin sur chaque menu "Vous êtes" du DOM. Passe
      // par once()+context (et non un jQuery(...).each() au top-level du
      // fichier) pour fonctionner même si ce bloc arrive après coup dans
      // le DOM (placeholder BigPipe, Ajax...).
      once('sideMenuInit', '.navigation-vousetes', context).forEach((nav) => {
        nav.sideMenuInstance = new sideMenu(nav);
      });
    },
  };

  // Menu principal du header : dropdowns desktop + comportement mobile
  // associé au burger. show.bs.dropdown/hide.bs.dropdown/show.bs.collapse
  // sont des évènements jQuery-only de Bootstrap 4 (bus interne de jQuery,
  // pas dispatchEvent — non observables en JS natif) : gardés en jQuery
  // pour l'écoute. .slideDown()/.slideUp() sont des effets jQuery core
  // (pas du Bootstrap) sans équivalent vanilla simple : gardés tels quels
  // également (jQuery reste de toute façon chargé sitewide via Bootstrap 4).
  Drupal.behaviors.menuMain = {
    attach(context) {
      const isDesktop = window.matchMedia('(min-width: 992px)').matches;

      if (isDesktop) {
        once('menuMainDesktop', '.dropdown', context).forEach((dropdown) => {
          jQuery(dropdown).on('show.bs.dropdown', function () {
            jQuery(this).find('.dropdown-menu').first().stop(true, true).slideDown();
            document.body.classList.add('menu-is-open');
            window.checkResize();
          });

          jQuery(dropdown).on('hide.bs.dropdown', function () {
            document.body.classList.remove('menu-is-open');
            jQuery(this).find('.dropdown-menu').first().stop(true, true).slideUp();
            window.checkResize();
          });
        });
      } else {
        // Ouverture du burger menu -> on enlève l'animation de fermeture des sous-menus.
        once('menuMainOverlay', '.overlay-menu', context).forEach((overlayMenu) => {
          jQuery(overlayMenu).on('show.bs.collapse', () => {
            document.querySelectorAll('.dropdown-menu').forEach((menu) => {
              menu.classList.remove('fermerSousmenu');
            });
          });
        });

        once('menuMainMobile', '.dropdown', context).forEach((dropdown) => {
          // Ouverture du sous-menu -> on enlève l'animation de fermeture des sous-menus.
          jQuery(dropdown).on('show.bs.dropdown', () => {
            document.querySelectorAll('.dropdown-menu').forEach((menu) => {
              menu.classList.remove('fermerSousmenu');
            });
            // Cache les icônes réseaux sociaux si le sous-menu est ouvert.
            document.querySelectorAll('.header-follow-us .follow-us-footer').forEach((el) => {
              el.classList.add('d-none');
            });
          });

          // Fermeture du sous-menu, burger toujours ouvert -> ajoute l'animation de fermeture.
          jQuery(dropdown).on('hide.bs.dropdown', () => {
            const burger = document.querySelector('.boutonMenuBurger');
            if (burger && burger.getAttribute('aria-expanded') === 'true') {
              document.querySelectorAll('.dropdown-menu').forEach((menu) => {
                menu.classList.add('fermerSousmenu');
              });
              document.querySelectorAll('.header-follow-us .follow-us-footer').forEach((el) => {
                el.classList.remove('d-none');
              });
            }
          });
        });
      }
    },
  };
})(Drupal, once);
